module.exports = __webpack_public_path__ + "img/dummyprod3@2x.69a1764a.png";